import { useState, useEffect, useContext } from "react";
import {
  Row,
  Col,
  Button,
  Form,
  Alert,
  Modal,
  ProgressBar,
  Card,
  Nav,
  Table,
  Dropdown,
} from "react-bootstrap";

import _ from "lodash";
import axios from "axios";
import moment from "moment";
import Utils from "../../common/Utils";
import { UserContext } from "../../common";

import DropdownMenu from "./../cqc/DropdownMenu";

const Userprofile = (props) => {
  const { userData } = useContext(UserContext);

  const targetUserId =
    _.get(props, "data.id") ||
    (typeof props.data === "number" || typeof props.data === "string" ? props.data : null) ||
    0;

  const [data, setData] = useState({});
  const [udocs, setUDocs] = useState({
    doctypes: [],
    userdocs: [],
    userdocfiles: [],
    counts: [],
    udgs: [],
  });
  const [loading, setLoading] = useState(true);
  const [dtype, setDType] = useState(parseInt(_.get(props, "cat", 0)));
  const [resources, setResources] = useState(false);
  const [upload, setUpload] = useState(false);
  const [trail, setTrail] = useState(false);
  const [sall, setsall] = useState(props.status);
  const [gapStatus, setGapStatus] = useState(props.gapStatus);
  const [udNote, showUDNote] = useState(false);
  const [notes, setNotes] = useState([]);
  const [saveNote, setSaveNote] = useState(false);

  const [msg, setMsg] = useState(false);
  const [loadres, setLoadres] = useState(false);
  const [uploading, setUploading] = useState(false);
  var onetimestatus = props.status !== undefined ? props.status : 0;

  const profileDetails = (status = onetimestatus ? onetimestatus : 0, showLoading = true) => {
    if (!targetUserId) {
      setLoading(false);
      return;
    }
    if (showLoading) {
      setLoading(true);
    }

    onetimestatus = 0;
    axios
      .get(
        Utils.apiUrl(`users/fetchprofile/${targetUserId}`) +
          "?show=1&status=" +
          status,
        Utils.apiHeaders(),
      )
      .then((res) => {
        if (res.data && res.data.success) {
          setData(_.get(res, "data.profile", {}));
          setUDocs({
            doctypes: _.get(res, "data.doctypes", []),
            userdocs: _.get(res, "data.userdocs", []),
            userdocfiles: _.get(res, "data.userdocfiles", []),
            counts: _.get(res, "data.counts", []),
            udgs: _.get(res, "data.udgs", []),
          });
        }
        if (showLoading) {
          setLoading(false);
        }
      })
      .catch((err) => {
        if (showLoading) {
          setLoading(false);
        }
        console.log(err);
      });
  };

  useEffect(profileDetails, []);

  const renderProfile = () => {
    return (
      <div className="dt-card p-3 p-md-4 mb-3" style={{ overflow: "hidden", wordBreak: "break-word" }}>
        <h4 className="mb-3" style={{ color: "var(--dt-navy)" }}>
          <b>
            {_.get(data, "title", "")} {_.get(data, "firstname", "")}{" "}
            {_.get(data, "middlename", "")} {_.get(data, "lastname", "")}
          </b>
        </h4>
        <Row className="g-3">
          <Col xs={12} sm={6} md={4} className="mb-2">
            <h6 className="fw-bold text-muted text-uppercase small" style={{ letterSpacing: "0.5px" }}>
              Personal Details
            </h6>
            <div>
              <b>Phone Number: </b>
              {_.get(data, "phone", " - ")}
            </div>
            <div>
              <b>Email ID: </b>
              {_.get(data, "email", " - ")}
            </div>
            <div>
              <b>GDC Number: </b>
              {_.get(data, "profile.gdc", " - ")}
            </div>

            <div>
              <b>Designation: </b>
              {_.get(data, "designation", " - ")}
            </div>
            <div>
              <b>Gender: </b>
              {_.get(data, "profile.gender", " - ")}
            </div>
          </Col>
          <Col xs={12} sm={6} md={4} className="mb-2">
            <h6 className="fw-bold text-muted text-uppercase small" style={{ letterSpacing: "0.5px" }}>
              Other Details
            </h6>
            <div>
              <b>Date of Birth: </b>
              {_.get(data, "profile.dob", " - ")}
            </div>
            <div>
              <b>Employment Start Date: </b>
              {_.get(data, "profile.doj", " - ")}
            </div>
            <div>
              <b>Employment Finish Date: </b>
              {_.get(data, "profile.lwd", " - ")}
            </div>
            <div>
              <b>Pronouns: </b>
              {_.get(data, "profile.pronoun", " - ")}
            </div>
          </Col>
          <Col xs={12} sm={6} md={4} className="mb-2">
            <h6 className="fw-bold text-muted text-uppercase small" style={{ letterSpacing: "0.5px" }}>
              Bank Account Details
            </h6>
            <div>
              <b>A/C Number: </b>
              {_.get(data, "profile.acnum", " - ")}
            </div>
            <div>
              <b>SORT/IFSC Code: </b>
              {_.get(data, "profile.ifsc", " - ")}
            </div>
            <div>
              <b>Bank Name: </b>
              {_.get(data, "profile.bank", " - ")}
            </div>
            <div>
              <b>Branch: </b>
              {_.get(data, "profile.branch", " - ")}
            </div>
          </Col>
        </Row>
        <div className="my-2 p-2 bg-light rounded" style={{ wordBreak: "break-word", overflow: "hidden" }}>
          <b>Notes:</b>{" "}
          <div
            style={{
              wordBreak: "break-word",
            }}
            dangerouslySetInnerHTML={{
              __html: _.get(data, "profile.notes", " - "),
            }}
          ></div>
        </div>
        <Row className="g-3 mt-1">
          <Col xs={12} sm={6} md={4} className="mb-2">
            <h6 className="fw-bold text-muted text-uppercase small" style={{ letterSpacing: "0.5px" }}>
              1st Emergency Contact
            </h6>
            <div>
              <b>Relationship: </b>
              {_.get(data, "profile.relship1", " - ")}
            </div>
            <div>
              <b>Name: </b>
              {_.get(data, "profile.name1", " - ")}
            </div>
            <div>
              <b>Address:</b>
              {_.get(data, "profile.address1", " - ")}
            </div>
            <div>
              <b>Phone:</b>
              {_.get(data, "profile.phone1", " - ")}
            </div>
          </Col>

          <Col xs={12} sm={6} md={4} className="mb-2">
            <h6 className="fw-bold text-muted text-uppercase small" style={{ letterSpacing: "0.5px" }}>
              2nd Emergency Contact
            </h6>
            <div>
              <b>Relationship: </b>
              {_.get(data, "profile.relship2", " - ")}
            </div>
            <div>
              <b>Name: </b>
              {_.get(data, "profile.name2", " - ")}
            </div>
            <div>
              <b>Address: </b>
              {_.get(data, "profile.address2", " - ")}
            </div>
            <div>
              <b>Phone: </b>
              {_.get(data, "profile.phone2", " - ")}
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const docSummery = () => {
    return (
      <Row className="g-3 mb-3">
        <Col xs={6} sm={6} md={3}>
          <div
            className={`dt-card p-3 d-flex align-items-center gap-3 h-100 ${sall === 1 ? "border-success shadow-sm" : ""}`}
            style={{ cursor: "pointer", transition: "all 0.2s" }}
            title="View all Approved Documents"
            onClick={() => {
              const newStatus = sall === 1 ? 0 : 1;
              setsall(newStatus);
              profileDetails(newStatus);
            }}
          >
            <div
              className="dt-counter-badge"
              style={{
                backgroundColor: "rgba(16, 185, 129, 0.15)",
                color: "#10B981"
              }}
            >
              {_.get(udocs, "counts[0].app_count", 0)}
            </div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Approved</div>
              <div className="fw-bold" style={{ fontSize: "13px", color: "var(--dt-navy)" }}>Documents</div>
            </div>
          </div>
        </Col>
        <Col xs={6} sm={6} md={3}>
          <div
            className={`dt-card p-3 d-flex align-items-center gap-3 h-100 ${sall === 2 ? "border-warning shadow-sm" : ""}`}
            style={{ cursor: "pointer", transition: "all 0.2s" }}
            title="View all Pending Documents"
            onClick={() => {
              const newStatus = sall === 2 ? 0 : 2;
              setsall(newStatus);
              profileDetails(newStatus);
            }}
          >
            <div
              className="dt-counter-badge"
              style={{
                backgroundColor: "rgba(245, 158, 11, 0.15)",
                color: "#F59E0B"
              }}
            >
              {_.get(udocs, "counts[0].pend_count", 0)}
            </div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Pending</div>
              <div className="fw-bold" style={{ fontSize: "13px", color: "var(--dt-navy)" }}>Documents</div>
            </div>
          </div>
        </Col>
        <Col xs={6} sm={6} md={3}>
          <div
            className={`dt-card p-3 d-flex align-items-center gap-3 h-100 ${sall === 3 ? "border-danger shadow-sm" : ""}`}
            style={{ cursor: "pointer", transition: "all 0.2s" }}
            title="View all Disapproved Documents"
            onClick={() => {
              const newStatus = sall === 3 ? 0 : 3;
              setsall(newStatus);
              profileDetails(newStatus);
            }}
          >
            <div
              className="dt-counter-badge"
              style={{
                backgroundColor: "rgba(239, 68, 68, 0.15)",
                color: "#EF4444"
              }}
            >
              {_.get(udocs, "counts[0].disapp_count", 0)}
            </div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Disapproved</div>
              <div className="fw-bold" style={{ fontSize: "13px", color: "var(--dt-navy)" }}>Documents</div>
            </div>
          </div>
        </Col>
        <Col xs={6} sm={6} md={3}>
          <div
            className={`dt-card p-3 d-flex align-items-center gap-3 h-100 ${sall === 4 ? "border-danger shadow-sm" : ""}`}
            style={{ cursor: "pointer", transition: "all 0.2s" }}
            title="View all Expired Documents"
            onClick={() => {
              const newStatus = sall === 4 ? 0 : 4;
              setsall(newStatus);
              profileDetails(newStatus);
            }}
          >
            <div
              className="dt-counter-badge"
              style={{
                backgroundColor: "rgba(220, 38, 38, 0.15)",
                color: "#DC2626"
              }}
            >
              {_.get(udocs, "counts[0].expire_count", 0)}
            </div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Expired</div>
              <div className="fw-bold" style={{ fontSize: "13px", color: "var(--dt-navy)" }}>Documents</div>
            </div>
          </div>
        </Col>
      </Row>
    );
  };

  const docGapSummary = () => {
    return (
      <Row className="row-cols-2 row-cols-sm-3 row-cols-lg-5 g-2 my-2">
        <Col>
          <div
            className={`dt-card p-3 d-flex align-items-center gap-3 h-100 ${gapStatus === 0 && dtype === 0 && sall === 0 ? "border-primary shadow-sm" : ""}`}
            style={{ cursor: "pointer", transition: "all 0.2s" }}
            title="View all documents"
            onClick={() => {
              setGapStatus(0);
              setDType(0);
              setsall(0);
              profileDetails(0);
            }}
          >
            <div
              className="dt-counter-badge"
              style={{
                backgroundColor: "#070D59",
                color: "#ffffff"
              }}
            >
              {_.get(udocs.counts, "[0].total", 0)}
            </div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Total</div>
              <div className="fw-bold" style={{ fontSize: "13px", color: "var(--dt-navy)" }}>Documents</div>
            </div>
          </div>
        </Col>
        <Col>
          <div
            className={`dt-card p-3 d-flex align-items-center gap-3 h-100 ${gapStatus === 1 ? "border-success shadow-sm" : ""}`}
            style={{ cursor: "pointer", transition: "all 0.2s" }}
            title="View all Have this document"
            onClick={() => {
              setGapStatus(1);
              setDType(0);
              setsall(0);
              profileDetails(0);
            }}
          >
            <div
              className="dt-counter-badge"
              style={{
                backgroundColor: "#10B981",
                color: "#ffffff"
              }}
            >
              {_.size(_.filter(udocs.udgs, (gs) => gs.gap_status == 1))}
            </div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Have This</div>
              <div className="fw-bold" style={{ fontSize: "13px", color: "#10B981" }}>Verified</div>
            </div>
          </div>
        </Col>
        <Col>
          <div
            className={`dt-card p-3 d-flex align-items-center gap-3 h-100 ${gapStatus === 2 ? "border-warning shadow-sm" : ""}`}
            style={{ cursor: "pointer", transition: "all 0.2s" }}
            title="View all Working on it"
            onClick={() => {
              setGapStatus(2);
              setDType(0);
              setsall(0);
              profileDetails(0);
            }}
          >
            <div
              className="dt-counter-badge"
              style={{
                backgroundColor: "#F59E0B",
                color: "#ffffff"
              }}
            >
              {_.size(_.filter(udocs.udgs, (gs) => gs.gap_status == 2))}
            </div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>In Progress</div>
              <div className="fw-bold" style={{ fontSize: "13px", color: "#F59E0B" }}>Working on it</div>
            </div>
          </div>
        </Col>
        <Col>
          <div
            className={`dt-card p-3 d-flex align-items-center gap-3 h-100 ${gapStatus === 3 ? "border-danger shadow-sm" : ""}`}
            style={{ cursor: "pointer", transition: "all 0.2s" }}
            title="View all Don't Have"
            onClick={() => {
              setGapStatus(3);
              setDType(0);
              setsall(0);
              profileDetails(0);
            }}
          >
            <div
              className="dt-counter-badge"
              style={{
                backgroundColor: "#EF4444",
                color: "#ffffff"
              }}
            >
              {_.size(_.filter(udocs.udgs, (gs) => gs.gap_status == 3))}
            </div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Missing</div>
              <div className="fw-bold" style={{ fontSize: "13px", color: "#EF4444" }}>Don't Have</div>
            </div>
          </div>
        </Col>
        <Col>
          <div
            className={`dt-card p-3 d-flex align-items-center gap-3 h-100 ${gapStatus === 4 ? "border-secondary shadow-sm" : ""}`}
            style={{ cursor: "pointer", transition: "all 0.2s" }}
            title="View all N/A"
            onClick={() => {
              setGapStatus(4);
              setDType(0);
              setsall(0);
              profileDetails(0);
            }}
          >
            <div
              className="dt-counter-badge"
              style={{
                backgroundColor: "#64748B",
                color: "#ffffff"
              }}
            >
              {_.size(_.filter(udocs.udgs, (gs) => gs.gap_status == 4))}
            </div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Exempt</div>
              <div className="fw-bold" style={{ fontSize: "13px", color: "#64748B" }}>N/A</div>
            </div>
          </div>
        </Col>
      </Row>
    );
  };

  const showResources = () => {
    return (
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={true}
        onHide={() => setResources(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Resources
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {_.get(resources.files, "length", 0) > 0 && <h3>Documents</h3>}
          <ol>
            {_.map(resources.files, (r) => (
              <li key={r} className="py-1">
                {/* <a href={Utils.apiUrl("users/downloadud") + "/" + r}> */}
                <a
                  target="_blank"
                  href={Utils.viewerLink(r, `users/downloadud/${r}`)}
                >
                  {r}
                </a>
                {/* {r}
                </a> */}
              </li>
            ))}
          </ol>
          {_.get(resources.links, "length", 0) > 0 && <h3>Links</h3>}
          <ol>
            {_.map(resources.links, (r) => (
              <li key={r} className="py-1">
                <a href={r} target="_blank">
                  {r}
                </a>
              </li>
            ))}
          </ol>
        </Modal.Body>
      </Modal>
    );
  };

  const getColor = (doc) => {
    if (!doc || !doc.id) return "#0d6efd";
    const filteredData = (udocs?.userdocfiles || []).filter(
      (item) => parseInt(item?.udid) === parseInt(doc?.id),
    );
    if (!filteredData || filteredData.length === 0) {
      return "#0d6efd"; // Vibrant blue for no doc uploaded
    }
    // Find max id for latest doc
    const ids = filteredData.map((item) => parseInt(item?.id)).filter((id) => !isNaN(id));
    const maxId = ids.length > 0 ? Math.max(...ids) : null;
    const lastDoc = filteredData.find(
      (item) => parseInt(item?.id) === maxId,
    ) || filteredData[0];

    if (!lastDoc) return "#0d6efd";

    let settings = {};
    try {
      settings = typeof doc.settings === "string" && doc.settings.trim() !== "" ? JSON.parse(doc.settings) : (doc.settings || {});
    } catch(e) {
      settings = {};
    }

    if (lastDoc.exp_status == "1" && parseInt(settings?.flag) !== 4 && lastDoc.expire_on) {
      return "#DC2626"; // Red for expired
    }
    if (lastDoc.doc_status == "3") {
      return "#EF4444"; // Red for disapproved
    }
    if (
      filteredData.some((d) => d?.doc_status == "2" && (d?.exp_status == "0" || parseInt(settings?.flag) === 4 || !d?.expire_on))
    ) {
      return "#F59E0B"; // Amber for pending
    }
    return "#10B981"; // Green for approved/complete
  };

  const changestatus = (id, status, msg = "") => {
    var postvars = `&id=${id}&status=${status}&time=${new moment().format("YYYY-MM-DD HH:mm:ss")}&msg=${msg}`;
    axios
      .post(Utils.apiUrl(`users/changeudfstatus`), postvars, Utils.apiHeaders())
      .then((res) => {
        setLoadres(false);
        if (res.data.success) {
          setUDocs((prevUdocs) => {
            return {
              ...prevUdocs,
              userdocfiles: prevUdocs.userdocfiles.map((userdocfile) => {
                if (userdocfile.id === id) {
                  // Update the userdocfile with the matching ID
                  return { ...userdocfile, ...res.data.udf };
                }
                return userdocfile;
              }),
            };
          });
          setMsg(false);
          profileDetails(sall, false);
          if (props.onUpdate) {
            props.onUpdate();
          }
        } else {
          window.alert(
            _.isObject(res.data.message)
              ? Object.values(res.data.message).join(",")
              : res.data.message,
          );
        }
      })
      .catch((err) => console.log(err));
  };

  const uploadFile = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();
    setUploading(true);
    setLoadres(parseInt(frm.udid.value));

    let formData = new FormData(frm);
    formData.append("time", new moment().format("YYYY-MM-DD HH:mm:ss"));

    axios
      .post(Utils.apiUrl("users/uploadudf"), formData, Utils.apiHeaders())
      .then((res) => {
        setUploading(false);
        setLoadres(false);
        if (res.data.success) {
          setUDocs((prev) => ({
            ...prev,
            userdocfiles: [...prev.userdocfiles.filter((f) => f.id !== res.data.udf.id), res.data.udf],
          }));
          profileDetails(sall, false);
          frm.reset();
          if (props.onUpdate) {
            props.onUpdate();
          }
        } else {
          window.alert(
            _.isObject(res.data.message)
              ? Object.values(res.data.message).join(",")
              : res.data.message,
          );
        }
      })
      .catch((err) => {
        setUploading(false);
        setLoadres(false);
        console.log(err);
      });
  };

  const showUpload = () => {
    let udf = _.filter(
      udocs.userdocfiles,
      (udfs) => parseInt(udfs.udid) === parseInt(upload),
    );
    let ud = _.filter(
      udocs.userdocs,
      (uds) => parseInt(uds.id) === parseInt(upload),
    );
    const selectedDoc = ud[0] || (udocs.userdocs || []).find(uds => parseInt(uds.id) === parseInt(upload)) || {};
    let settings = {};
    try {
      settings = typeof selectedDoc?.settings === "string" && selectedDoc?.settings.trim() !== "" ? JSON.parse(selectedDoc.settings) : (selectedDoc?.settings || {});
    } catch (e) {
      settings = {};
    }

    const targetUserId = _.get(data, "id", props.data?.id || 0);

    return (
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={true}
        onHide={() => !uploading && setUpload(false)}
      >
        <Modal.Header closeButton={!uploading}>
          <Modal.Title id="contained-modal-title-vcenter">
            {selectedDoc.title || "Manage Document"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table responsive={true}>
            <thead>
              <tr>
                <td style={{ maxWidth: "150px" }}>Document Name</td>
                <td>Status</td>
                <td>Upload On</td>
                <td>Status(Update On)</td>
                <td>Expire On</td>
                <td>
                  <img src="images/download.png" alt="download" />
                </td>
              </tr>
            </thead>
            <tbody>
              {_.map(udf, (r) => (
                <tr key={r.id || r.furl}>
                  <td>{r.udoc}</td>
                  <td>{showStatus(r, "manage")}</td>
                  <td>{r.created_at}</td>
                  <td>{r.updated_at}</td>
                  <td>{r.expire_on || "Never Expire"}</td>
                  <td>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={Utils.viewerLink(
                        r.udoc,
                        `users/downloadudf/${r.furl}`,
                      )}
                    >
                      <img src="images/download.png" alt="download" />
                    </a>
                  </td>
                </tr>
              ))}
              {udf.length === 0 && (
                <tr>
                  <td colSpan={6} className="text-center text-muted py-3">No previous uploads found for this document.</td>
                </tr>
              )}
            </tbody>
          </Table>

          {uploading && (
            <div className="alert alert-info py-2 px-3 mt-3 d-flex align-items-center gap-2">
              <div className="spinner-border spinner-border-sm text-primary" role="status"></div>
              <span className="fw-semibold">Uploading document, please wait...</span>
            </div>
          )}

          {_.get(userData, "is_super_user", false) && (
            <Form onSubmit={uploadFile}>
              <input type="hidden" name="uid" value={targetUserId} />
              <input type="hidden" name="udid" value={upload} />
              <div className="row mt-4 d-flex align-items-end">
                <div className="col-md-4">
                  <label className="form-label small fw-bold">Select File *</label>
                  <input type="file" required name="udoc" className="form-control" disabled={uploading} />
                </div>
                {settings.flag == 3 && (
                  <div className="col-md-4">
                    <label className="form-label small fw-bold">Expire Date (Optional)</label>
                    <input
                      type="date"
                      name="exp_date"
                      maxLength="255"
                      className="form-control"
                      disabled={uploading}
                      min={
                        new Date(new Date().getTime() + 24 * 60 * 60 * 1000)
                          .toISOString()
                          .split("T")[0]
                      }
                      format="dd/mm/yyyy"
                      onKeyDown={(e) => e.preventDefault()}
                      placeholder="Expire Date"
                    />
                  </div>
                )}
                <div className="col-md-3 mt-2">
                  <Button variant="primary" type="submit" disabled={uploading} className="d-flex align-items-center gap-2">
                    {uploading ? (
                      <>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <span>Uploading...</span>
                      </>
                    ) : (
                      "Upload"
                    )}
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </Modal.Body>
      </Modal>
    );
  };

  const showMsg = () => {
    return (
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={true}
        onHide={() => setMsg(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Disapproved
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              changestatus(msg.id, msg.status, e.currentTarget.msg.value);
            }}
          >
            <div className="row  d-flex align-items-end">
              <div className="col-sm-8 mb-2">
                <label htmlFor="msg">Reason for Disapproval</label>
                <textarea name="msg" id="msg" cols="60" rows="5" className="form-control" required />
              </div>
            </div>
            <Button variant="primary" type="submit">
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    );
  };

  const showStatus = (data, opt) => {
    if (data.exp_status == 0 || !data.expire_on) {
      if (data.doc_status == 1) {
        return <span className="text-success">Approved</span>;
      } else if (data.doc_status == 2) {
        if (opt == "trail" || data.user_id == userData.uid) {
          return <span className="text-warning">Pending</span>;
        } else {
          return (
            <div>
              <Button
                type="button"
                className="m-1 mt-0"
                variant="success"
                onClick={() => changestatus(data.id, 1)}
              >
                Approved
              </Button>
              <Button
                type="button"
                className="m-1 mt-0"
                variant="danger"
                onClick={() => setMsg({ id: data.id, status: 3 })}
              >
                Disapproved
              </Button>
            </div>
          );
        }
      } else if (data.doc_status == 3) {
        return (
          <span className="text-danger" title={data.msg ?? ""}>
            Disapproved {data.msg && <i className="bi bi-chat-left-dots ms-1"></i>}
          </span>
        );
      }
    } else {
      return <span className="text-danger">Expired</span>;
    }
  };

  const showTrail = () => {
    let udf = _.filter(
      udocs.userdocfiles,
      (udfs) => parseInt(udfs.udid) === parseInt(trail),
    );
    let ud = _.filter(
      udocs.userdocs,
      (uds) => parseInt(uds.id) === parseInt(trail),
    );
    const selectedDoc = ud[0] || (udocs.userdocs || []).find(uds => parseInt(uds.id) === parseInt(trail)) || {};

    return (
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={true}
        onHide={() => setTrail(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {selectedDoc.title || "Document Trail"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table responsive={true}>
            <thead>
              <tr>
                <td>Name</td>
                <td>Upload On</td>
                <td>Status</td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              {_.map(udf, (r) => (
                <tr key={r.id || r.furl}>
                  <td>{r.udoc}</td>
                  <td>{r.created_at}</td>
                  <td>{showStatus(r, "trail")}</td>
                  <td>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={Utils.viewerLink(
                        r.udoc,
                        `users/downloadudf/${r.furl}`,
                      )}
                    >
                      <img src="images/download.png" alt="download" />
                    </a>
                  </td>
                </tr>
              ))}
              {udf.length === 0 && (
                <tr>
                  <td colSpan={4} className="text-center text-muted py-3">No history trail found.</td>
                </tr>
              )}
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>
    );
  };

  const renderGapStatusFilters = () => {
    let uds = udocs?.userdocs || [];
    if (dtype > 0) {
      uds = _.filter(uds, (p) => parseInt(p?.cat) === parseInt(dtype));
    }

    return (
      <>
        {_.map(_.slice(Utils.getGapStatusList(), 1), (gs) => {
          let udgscol = _.filter(udocs?.udgs || [], (udg) => parseInt(udg?.gap_status) === parseInt(gs[0]));
          udgscol = _.filter(uds, (ud) => _.includes(_.map(udgscol, (u) => parseInt(u?.udid)), parseInt(ud?.id)));

          const isActive = parseInt(gapStatus) === parseInt(gs[0]);
          return (
            <Nav.Item className="me-1" key={gs[0]}>
              <Nav.Link
                style={{
                  backgroundColor: gs[3],
                  borderRadius: "6px",
                  padding: "6px 10px",
                  fontSize: "12px",
                  fontWeight: 600,
                  opacity: isActive ? 1 : 0.85,
                  boxShadow: isActive ? "0 0 0 2px #000, 0 2px 6px rgba(0,0,0,0.2)" : "none"
                }}
                className="text-white"
                eventKey={gs[0]}
                onClick={() => setGapStatus(parseInt(gapStatus) === parseInt(gs[0]) ? 0 : parseInt(gs[0]))}
              >
                {udgscol.length}/{uds.length}
              </Nav.Link>
            </Nav.Item>
          );
        })}
      </>
    );
  };

  const renderDocTypes = () => {
    return (
      <div className="mt-4">
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
          <div className="d-flex flex-wrap gap-1 align-items-center" style={{ overflowX: "auto", maxWidth: "100%" }}>
            <Nav variant="pills" className="px-0 flex-wrap gap-1" activeKey={dtype} onSelect={setDType}>
              <Nav.Item>
                <Nav.Link
                  eventKey={0}
                  onClick={() => {
                    setDType(0);
                    setGapStatus(0);
                  }}
                  style={{ borderRadius: "8px", fontSize: "12px", fontWeight: 600 }}
                >
                  All
                </Nav.Link>
              </Nav.Item>
              {_.map(udocs?.doctypes || [], (cat, catidx) => (
                <Nav.Item key={catidx}>
                  <Nav.Link
                    eventKey={catidx}
                    onClick={() => {
                      setDType(catidx);
                      setGapStatus(0);
                    }}
                    style={{ borderRadius: "8px", fontSize: "12px", fontWeight: 600 }}
                  >
                    {cat}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </div>
          <div className="d-flex flex-wrap gap-1 align-items-center ms-auto" style={{ overflowX: "auto", maxWidth: "100%" }}>
            <Nav variant="pills" className="px-0 flex-wrap gap-1" activeKey={gapStatus}>
              {renderGapStatusFilters()}
            </Nav>
          </div>
        </div>
        <Card style={{ backgroundColor: "#CEDDEF88" }}>
          <Card.Body className="p-2 p-md-3">
            {/* Mobile Card List View */}
            <div className="d-block d-md-none">
              {renderMobileUDF()}
            </div>

            {/* Desktop Table View */}
            <div className="table-responsive d-none d-md-block">
              <Table responsive hover className="m-0 align-middle">
                <thead>
                  <tr>
                    <th className="text-end" width="50">
                      ##
                    </th>
                    <th>Document Title</th>
                    {parseInt(dtype) === 0 && <th>Category</th>}
                    <th>Resources</th>
                    <th>Action</th>
                    <th>Trail</th>
                    <th>Gap Analysis</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>{renderUDF()}</tbody>
              </Table>
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  };

  const renderMobileUDF = () => {
    let uds = udocs?.userdocs || [];
    if (dtype != 0) {
      uds = _.filter(
        uds,
        (p) => parseInt(p?.cat) === parseInt(dtype),
      );
    }

    if (parseInt(sall) === 1) {
      uds = _.filter(uds, (p) => getColor(p) === "#10B981");
    } else if (parseInt(sall) === 2) {
      uds = _.filter(uds, (p) => getColor(p) === "#F59E0B");
    } else if (parseInt(sall) === 3) {
      uds = _.filter(uds, (p) => getColor(p) === "#EF4444");
    } else if (parseInt(sall) === 4) {
      uds = _.filter(uds, (p) => getColor(p) === "#DC2626");
    }

    if (gapStatus > 0) {
      uds = _.filter(uds, (u) =>
        _.includes(
          _.map(
            _.filter(udocs?.udgs || [], (g) => g?.gap_status == gapStatus),
            (g) => g?.udid,
          ),
          u?.id,
        ),
      );
    }

    if (uds && uds.length > 0) {
      return _.map(uds, (ud, idx) => {
        let r = [];
        try {
          r = typeof ud?.resources === "string" && ud?.resources.trim() !== "" ? JSON.parse(ud.resources) : (Array.isArray(ud?.resources) ? ud.resources : []);
        } catch(e) { r = []; }
        const isUpload = getColor(ud) === "#0d6efd" || getColor(ud) === "#070d59";

        return (
          <div key={ud.id || idx} id={`doc-item-${ud.id}`} className="bg-white p-3 rounded mb-2 border shadow-sm">
            <div className="d-flex align-items-start justify-content-between gap-2 mb-2">
              <div className="d-flex align-items-center gap-2">
                <span className="badge bg-primary text-white" style={{ fontSize: "11px" }}>{Utils.addZero(idx + 1)}</span>
                <span className="fw-bold" style={{ fontSize: "13.5px", color: "var(--dt-navy)" }}>{ud.title}</span>
              </div>
              <img
                src={`${process.env.PUBLIC_URL}/images/notes.png`}
                className="clickable"
                style={{ width: "20px", height: "20px" }}
                title={`Notes for ${ud.title}`}
                onClick={() => showUDNote(ud)}
                alt="notes"
              />
            </div>
            {parseInt(dtype) === 0 && (
              <div className="mb-2">
                <span className="badge bg-light text-secondary border" style={{ fontSize: "10.5px" }}>{udocs?.doctypes?.[ud.cat] || "General"}</span>
              </div>
            )}
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 pt-2 border-top">
              <div>
                <DropdownMenu
                  key={ud.id}
                  doc={{
                    id: ud.id,
                    gap_status: _.get(
                      _.find(udocs?.udgs || [], (gs) => gs.udid == ud.id),
                      "gap_status",
                      0,
                    ),
                  }}
                  changestatus={changeGapStatus}
                />
              </div>
              <div className="d-flex align-items-center gap-1">
                {r.length > 0 && (
                  <Button
                    size="sm"
                    type="button"
                    variant="outline-info"
                    className="rounded-pill px-2 py-0"
                    style={{ fontSize: "11px" }}
                    onClick={() => setResources(r)}
                  >
                    Resources
                  </Button>
                )}
                <Button
                  size="sm"
                  className="rounded-pill px-2 py-0"
                  type="button"
                  variant="outline-secondary"
                  style={{ fontSize: "11px" }}
                  onClick={() => setTrail(ud.id)}
                  disabled={!ud.id}
                >
                  Trail
                </Button>
                <Button
                  size="sm"
                  variant="contained"
                  className="rounded-pill px-3 py-1 fw-bold"
                  type="button"
                  style={{ backgroundColor: getColor(ud), color: "white", border: "none", fontSize: "12px" }}
                  onClick={() => setUpload(ud.id)}
                >
                  {isUpload ? "Upload" : "Manage"}
                </Button>
              </div>
            </div>
          </div>
        );
      });
    } else {
      return (
        <Alert variant="warning" className="my-2">
          No documents found in this section!
        </Alert>
      );
    }
  };

  const renderUDF = () => {
    let uds = udocs?.userdocs || [];
    if (dtype != 0) {
      uds = _.filter(
        uds,
        (p) => parseInt(p?.cat) === parseInt(dtype),
      );
    }

    if (parseInt(sall) === 1) {
      uds = _.filter(uds, (p) => getColor(p) === "#10B981");
    } else if (parseInt(sall) === 2) {
      uds = _.filter(uds, (p) => getColor(p) === "#F59E0B");
    } else if (parseInt(sall) === 3) {
      uds = _.filter(uds, (p) => getColor(p) === "#EF4444");
    } else if (parseInt(sall) === 4) {
      uds = _.filter(uds, (p) => getColor(p) === "#DC2626");
    }

    if (gapStatus > 0) {
      uds = _.filter(uds, (u) =>
        _.includes(
          _.map(
            _.filter(udocs?.udgs || [], (g) => g?.gap_status == gapStatus),
            (g) => g?.udid,
          ),
          u?.id,
        ),
      );
    }

    if (uds && uds.length > 0) {
      return _.map(uds, (ud, idx) => {
        return (
          <tr key={ud.id || idx} id={`doc-item-${ud.id}`}>
            <td className="text-end">
              <div className="badge bg-primary text-white">
                {Utils.addZero(idx + 1)}
              </div>
            </td>
            <td>
              <div className="fw-semibold text-dark" style={{ minWidth: "150px" }}>{ud.title}</div>
            </td>
            {parseInt(dtype) === 0 && (
              <td>
                <span className="badge bg-light text-secondary border">{udocs?.doctypes?.[ud.cat] || "General"}</span>
              </td>
            )}
            <td>
              <Button
                size="sm"
                type="button"
                variant="primary"
                className="rounded-pill px-3"
                onClick={() => {
                  let r = [];
                  try {
                    r = typeof ud?.resources === "string" && ud?.resources.trim() !== "" ? JSON.parse(ud.resources) : (Array.isArray(ud?.resources) ? ud.resources : []);
                  } catch(e) { r = []; }
                  setResources(r);
                }}
                disabled={!ud.id}
              >
                View
              </Button>
            </td>

            <td>
              <Button
                size="sm"
                variant="contained"
                className="rounded-pill px-3"
                type="button"
                style={{ backgroundColor: getColor(ud), color: "white", border: "none" }}
                onClick={() => setUpload(ud.id)}
              >
                {getColor(ud) === "#0d6efd" || getColor(ud) === "#070d59" ? "Upload" : "Manage"}
              </Button>
            </td>
            <td>
              <Button
                size="sm"
                className="rounded-pill px-3"
                type="button"
                variant="outline-primary"
                onClick={() => setTrail(ud.id)}
                disabled={!ud.id}
              >
                Trail
              </Button>
            </td>
            <td>
              <DropdownMenu
                key={ud.id}
                doc={{
                  id: ud.id,
                  gap_status: _.get(
                    _.find(udocs?.udgs || [], (gs) => gs.udid == ud.id),
                    "gap_status",
                    0,
                  ),
                }}
                changestatus={changeGapStatus}
              />
            </td>
            <td>
              <img
                src={`${process.env.PUBLIC_URL}/images/notes.png`}
                className="clickable"
                style={{ width: "20px", height: "20px" }}
                title={`Notes for ${ud.title}`}
                onClick={() => showUDNote(ud)}
                alt="notes"
              />
            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan={parseInt(dtype) === 0 ? 8 : 7}>
            <Alert variant="warning">
              No documents found in this section!
            </Alert>
          </td>
        </tr>
      );
    }
  };

  const changeGapStatus = (udid, gs) => {
    const postdata = `&uid=${targetUserId}&udid=${udid}&status=${gs}`;
    axios
      .post(Utils.apiUrl(`users/savegapstatus`), postdata, Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setUDocs((prev) => ({
            ...prev,
            udgs: _.get(res, "data.udgs", []),
          }));
          if (props.onUpdate) {
            props.onUpdate();
          }
          setTimeout(() => {
            const el = document.getElementById(`doc-item-${udid}`);
            if (el) {
              el.scrollIntoView({ block: "nearest", behavior: "smooth" });
            }
          }, 50);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchUDNotes = () => {
    if (udNote !== false && _.isUndefined(udNote.loading)) {
      showUDNote({ ...udNote, loading: true });
      axios
        .get(
          Utils.apiUrl(
            `users/fetchnotes?uid=${targetUserId}&udid=${udNote.id}`,
          ),
          Utils.apiHeaders(),
        )
        .then((res) => {
          showUDNote({ ...udNote, loading: false });
          if (res.data.success) {
            setNotes(res.data.data);
          } else {
            window.alert(res.data.message);
          }
        })
        .catch((err) => console.log(err));
    }
  };

  useEffect(fetchUDNotes, [udNote]);

  const saveUDNote = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();
    const formData = new FormData(frm);
    if (_.isEmpty(frm.note.value)) {
      window.alert("Please fill notes to save");
      return false;
    }
    formData.append("uddoc_id", udNote.id);
    formData.append("user_id", targetUserId);
    setSaveNote(true);
    axios
      .post(Utils.apiUrl(`users/savenote`), formData, Utils.apiHeaders())
      .then((res) => {
        setSaveNote(false);
        showUDNote(_.omit(udNote, ["notes", "loading"]));
      })
      .catch((err) => console.log(err));
  };

  const deleteNote = (nid) => {
    if (window.confirm("You are going to delete this note, continue?")) {
      setNotes(_.filter(notes, (n) => n.id !== nid));
      axios
        .delete(Utils.apiUrl(`users/delnote/${nid}`), Utils.apiHeaders())
        .catch((err) => console.log(err));
    }
  };

  const showNotesForUD = () => {
    return (
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={true}
        onHide={() => showUDNote(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Notes - {udNote.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {saveNote === true && (
            <Alert variant="info" className="p-3">
              <p className="loading-msg">Saving User Document Note..</p>
              <ProgressBar variant="info" animated now={100} />
            </Alert>
          )}
          {saveNote === false && (
            <>
              <Form onSubmit={saveUDNote}>
                <div className="d-flex">
                  <textarea
                    name="note"
                    required
                    className="form-control me-2"
                    rows={2}
                    placeholder="Enter your Note"
                  ></textarea>
                  <div className="ms-2">
                    <Button type="submit" variant="dark">
                      Submit
                    </Button>
                  </div>
                </div>
              </Form>
            </>
          )}
          {udNote.loading === true && (
            <Alert variant="warning" className="p-3">
              <p className="loading-msg">Fetching User Document Note..</p>
              <ProgressBar variant="warning" animated now={100} />
            </Alert>
          )}
          {udNote.loading === false && (
            <div style={{ maxHeight: "400px", overflow: "auto" }}>
              {_.get(notes, "length", 0) === 0 && (
                <Alert variant="danger" className="p-3">
                  <p className="loading-msg">No comments found!</p>
                </Alert>
              )}
              {_.map(notes, (note) => (
                <div key={note.id} className="d-flex mt-1 py-2 border-bottom">
                  <div>
                    <div className="badge bg-light text-dark">
                      {Utils.toLocal(note.created_at).format(
                        "HH:mm MMM DD, YY",
                      )}
                    </div>
                  </div>
                  <div className="text-start text-dark flex-grow-1">
                    {note.note}
                  </div>
                  {(userData.is_super_user ||
                    data.reporting_to == userData.uid) && (
                    <div className="text-end">
                      <img
                        src={`${process.env.PUBLIC_URL}/images/delete.png`}
                        className="clickable text-danger me-1"
                        title={`Delete this note!`}
                        onClick={() => deleteNote(note.id)}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </Modal.Body>
      </Modal>
    );
  };

  return (
    <div className="mt-4">
      {loading && (
        <Alert variant="info" className="p-3">
          <p className="loading-msg">Fetching details..</p>
          <ProgressBar variant="info" animated now={100} />
        </Alert>
      )}
      {!loading && (
        <>
          <Card border="light" className="shadow dashboardStats">
            <Card.Body className="py-0">
              {docSummery()}
              {renderProfile()}
              {docGapSummary()}

              {renderDocTypes()}
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                <a
                  href={
                    Utils.apiUrl("users/exportdata") +
                    "/" +
                    targetUserId +
                    (dtype > 0 ? "?cat=" + dtype + "&token=" + (Utils.getToken() || "") : "?token=" + (Utils.getToken() || ""))
                  }
                >
                  <Button
                    type="submit"
                    variant="primary"
                    className="shadow-cst p-0 text-light p-2 px-5"
                  >
                    Export {dtype > 0 ? (udocs?.doctypes?.[dtype] || "Category") : "All"} Data
                  </Button>
                </a>
              </div>
            </Card.Body>
          </Card>
          {resources && showResources()}
          {upload && showUpload()}
          {trail && showTrail()}
          {msg && showMsg()}
          {udNote !== false && showNotesForUD()}
        </>
      )}
    </div>
  );
};

export default Userprofile;
